export default function minTranslate() {
  return -this.snapGrid[0];
}


// WEBPACK FOOTER //
// ./node_modules/swiper/core/translate/minTranslate.js